import { useScript } from '#imports'

export default defineNuxtPlugin(() => {
  const { tempEnableBrightedge } = useFeatureFlags()
  if (tempEnableBrightedge) {
    const { onError } = useScript({
      src: 'https://cdn.bc0a.com/autopilot/f00000000297751/autopilot_sdk.js',
    })
    onError((error) => {
      console.warn('Failed to load Brightedge Autopilot script', error)
    })
  }
})
